import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/admin/AdminLayout";

const Steps = ({ redirect }) => (
  <ol className="text-xs text-slate-600 list-decimal ml-5 space-y-1 mb-3" data-testid="youtube-steps">
    <li>Open <b>console.cloud.google.com</b> with the Google account that owns your YouTube channel and create a project (e.g. "BachatRaja Shorts").</li>
    <li>APIs &amp; Services → Library → search <b>YouTube Data API v3</b> → Enable.</li>
    <li>APIs &amp; Services → OAuth consent screen → External → fill app name &amp; your email → add yourself as a test user → then press <b>Publish app</b> (otherwise Google logs you out every 7 days).</li>
    <li>Credentials → Create credentials → OAuth client ID → <b>Web application</b> → Authorised redirect URI: <code className="bg-slate-100 px-1 break-all" data-testid="youtube-redirect-uri">{redirect}</code></li>
    <li>Copy the Client ID and Client secret into admin → Integrations &amp; Keys → YouTube Shorts, then come back and press Connect YouTube.</li>
  </ol>
);

export const YouTubeCard = ({ yt, isAdmin, refresh }) => {
  const connect = async () => {
    try { const r = await api.get("/admin/youtube/connect"); window.location.href = r.data.authorization_url; } catch (e) { toast.error(errMsg(e)); }
  };
  const disconnect = async () => { if (!window.confirm("Disconnect YouTube?")) return; await api.delete("/admin/youtube"); refresh(); };
  return (
    <Panel title="YouTube Shorts" testid="youtube-panel">
      <p className="text-sm mb-3" data-testid="youtube-status">
        {yt.connected ? <b className="text-emerald-700">Connected · {yt.channel_title || "your channel"}</b>
          : yt.error ? <b className="text-red-600">{yt.error}</b>
          : yt.app_ready ? <b className="text-amber-700">Keys added - connect your YouTube channel</b>
          : <b className="text-red-600">Not set up - needs a free Google Cloud project</b>}
      </p>
      <p className="text-xs text-slate-500 mb-3">Approved Shorts scheduled in Social Media Manager are turned into a 12-second branded video (deal photo, price, code, captions - no voice) and uploaded as <b>unlisted</b>. Make them public in YouTube Studio when you're happy. Until Google reviews your project, YouTube may keep API uploads private - you can still switch each one to public yourself.</p>
      {!yt.connected && <Steps redirect={yt.redirect_uri} />}
      {isAdmin && (
        <div className="flex flex-wrap gap-2">
          {yt.app_ready && !yt.connected && <button onClick={connect} className="px-3 py-1.5 rounded-lg bg-red-600 text-white text-sm font-semibold" data-testid="youtube-connect-button">{yt.error ? "Reconnect YouTube" : "Connect YouTube"}</button>}
          {(yt.connected || yt.error) && <button onClick={disconnect} className="px-3 py-1.5 rounded-lg border border-red-200 text-red-600 text-sm font-semibold" data-testid="youtube-disconnect-button">Disconnect</button>}
        </div>
      )}
    </Panel>
  );
};
